import { NextPage } from 'next'
import { asPage, PageProps } from 'src/components/hoc/asPage'
import { ExhibitionSearch } from 'src/compositions/Exhibition/Search'

const ExhibitionSearchPage: NextPage<PageProps<{}>> = () => {
  return <ExhibitionSearch />
}

export default asPage(ExhibitionSearchPage, {
  pageTitle: '展示会検索',
  noindex: false,
})
